// Cari Detayları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.detail';

export const accountDetailGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Cari Detayları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu pencere bir carinin kayıtlı bilgilerini salt okunur olarak gösterir. Her bölümün ne anlama geldiğini ve hangi işte kullanıldığını adım adım anlatıyoruz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Cari adı'),
    body: t(`${G}.regions.body`, 'Bilgi bölümleri'),
    footer: t(`${G}.regions.footer`, 'Yazdır / Pasife Al'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Doğru cariye baktığınızı kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstte cari adı ve hesabın oluşturulma tarihi yer alır. Hesap pasife alınmışsa yanında kırmızı "Pasif Hesap" etiketi görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Temel Bilgiler'),
      text: t(`${G}.s2.text`, 'Cari kodu, cari grup, yetkili kişi ve notlar kaydın kimliğini belirler. İşlem yaparken doğru cariyi seçmek ve raporların tutarlı olması için önce bu bölümü kontrol edin.'),
      tips: [
        t(`${G}.s2.tip1`, '"Cari Hesap Bakiyesi Eksiye Düşemesin" işaretliyse bu carinin bakiyesi eksiye düşürülemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. İletişim Bilgileri'),
      text: t(`${G}.s3.text`, 'Sabit telefon, cep telefonu, e-posta ve web sitesiyle cariye doğrudan ulaşırsınız. Eksik veya eski iletişim bilgisi sipariş ve tahsilatta gecikmeye yol açabilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Vergi Bilgileri'),
      text: t(`${G}.s4.text`, 'Vergi dairesi, vergi numarası ve ticaret sicil numarası resmi belgelerde ve faturalarda kullanılır. Muhasebe kayıtları ve yasal uyum için doğru olmaları çok önemlidir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Adres Bilgileri'),
      text: t(`${G}.s5.text`, 'Ülke, il, ilçe, posta kodu ve açık adres sevkiyat, ziyaret ve resmi yazışmalarda esas alınır. Adresi güncel tutmak teslimat hatalarını ve iade riskini azaltır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Yazdırın veya pasife alın'),
      text: t(`${G}.s6.text`, '"Yazdır" cari bilgilerini kâğıda / PDF\'e döker. "Pasife Al" cariyi aktif listeden çıkarır; işlemden sonra hesap pasif görünür.'),
      tips: [
        t(`${G}.s6.tip1`, 'Pasife alma geri alınabilir; pasif cariler ⋮ menüsündeki "Pasif Cariler" listesinde görünür.'),
        t(`${G}.s6.tip2`, '"Genel Cari" pasife alınamaz.'),
      ],
    },
  ],
});
